export default __webpack_public_path__ + "static/media/white-close-button.8cf57c3d.svg";